'use strict';
(() => {
  function initGallery(scope = document) {
    scope.querySelectorAll('[data-in-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      const track = gallery.querySelector('[data-in-media-track]');
      const slides = [...gallery.querySelectorAll('[data-in-media]')];
      const dots = [...gallery.querySelectorAll('[data-in-gallery-dot]')];
      if (!track || !slides.length) return;
      let index = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      function markActive(number) {
        index = Math.max(0, Math.min(number, slides.length - 1));
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
          if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
      function goTo(number, instant = false) {
        markActive(number);
        track.scrollTo({left: index * track.clientWidth, behavior: instant || reducedMotion.matches ? 'auto' : 'smooth'});
      }
      let queued = false;
      track.addEventListener('scroll', () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          markActive(Math.round(track.scrollLeft / track.clientWidth));
          queued = false;
        });
      }, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.target !== track) return;
        const actions = {ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: slides.length - 1};
        if (!(event.key in actions)) return;
        event.preventDefault();
        goTo(actions[event.key]);
      });
      gallery.addEventListener('click', event => {
        const dot = event.target.closest('[data-in-gallery-dot]');
        if (!dot) return;
        const target = slides.findIndex(slide => slide.dataset.inMedia === dot.dataset.inGalleryDot);
        if (target >= 0) goTo(target);
      });
      gallery.addEventListener('idolnest:media-select', event => {
        const target = slides.findIndex(slide => slide.dataset.inMedia === String(event.detail.id));
        if (target >= 0) goTo(target);
      });
      const observer = new ResizeObserver(() => {
        if (!gallery.isConnected) { observer.disconnect(); return; }
        track.scrollTo({left: index * track.clientWidth, behavior: 'auto'});
      });
      observer.observe(track);
      goTo(index, true);
    });
  }
  initGallery();
  document.addEventListener('shopify:section:load', event => initGallery(event.target));
})();
